import React, { useEffect, useState, lazy } from "react";
const LoadingInner = lazy(() => import("@/app/loadingInner"));
import { capitalizeFirstLetter } from "@/utils";

const DataCompareStrength = (props) => {
  const [TeamComparisonChart, setTeamComparisonChart] = useState(null);
  const [tab, setTab] = useState("state");
  const match = props.match;
  const defaultComparison = {
    count: 0,
    battle: {
      hGrade: 0,
      gGrade: 0,
      all: {
        hWin: 0,
        hDraw: 0,
        hLoss: 0,
        hScore: 0,
        hGoal: 0,
        hRating: 0,
        hVSRating: 0,
        hRatingGame: 0,
        hPercent: 0,
        hGoalPercent: 0,
        hRatingPercent: 0,
        gWin: 0,
        gDraw: 0,
        gLoss: 0,
        gScore: 0,
        gGoal: 0,
        gRating: 0,
        gVSRating: 0,
        gRatingGame: 0,
        gPercent: 0,
        gGoalPercent: 0,
        gRatingPercent: 0,
      },
      same: {
        hWin: 0,
        hDraw: 0,
        hLoss: 0,
        hScore: 0,
        hGoal: 0,
        hRating: 0,
        hVSRating: 0,
        hRatingGame: 0,
        hPercent: 0,
        hGoalPercent: 0,
        hRatingPercent: 0,
        gWin: 0,
        gDraw: 0,
        gLoss: 0,
        gScore: 0,
        gGoal: 0,
        gRating: 0,
        gVSRating: 0,
        gRatingGame: 0,
        gPercent: 0,
        gGoalPercent: 0,
        gRatingPercent: 0,
      },
    },
    state: {
      hGrade: 0,
      gGrade: 0,
      all: {
        hWin: 0,
        hDraw: 0,
        hLoss: 0,
        hScore: 0,
        hGoal: 0,
        hRating: 0,
        hVSRating: 0,
        hRatingGame: 0,
        hPercent: 0,
        hGoalPercent: 0,
        hRatingPercent: 0,
        gWin: 0,
        gDraw: 0,
        gLoss: 0,
        gScore: 0,
        gGoal: 0,
        gRating: 0,
        gVSRating: 0,
        gRatingGame: 0,
        gPercent: 0,
        gGoalPercent: 0,
        gRatingPercent: 0,
      },
      same: {
        hWin: 0,
        hDraw: 0,
        hLoss: 0,
        hScore: 0,
        hGoal: 0,
        hRating: 0,
        hVSRating: 0,
        hRatingGame: 0,
        hPercent: 0,
        hGoalPercent: 0,
        hRatingPercent: 0,
        gWin: 0,
        gDraw: 0,
        gLoss: 0,
        gScore: 0,
        gGoal: 0,
        gRating: 0,
        gVSRating: 0,
        gRatingGame: 0,
        gPercent: 0,
        gGoalPercent: 0,
        gRatingPercent: 0,
      },
    },
    market: {
      hMarket: 0,
      gMarket: 0,
      hPercent: 0,
      gPercent: 0,
    },
    attack: {
      hGrade: 0,
      gGrade: 0,
      hGoal: 0,
      hPercent: 0,
      hTarget: 0,
      hTargetGame: 0,
      hTargetPercent: 0,
      gGoal: 0,
      gPercent: 0,
      gTarget: 0,
      gTargetGame: 0,
      gTargetPercent: 0,
      hSameGoal: 0,
      hSamePercent: 0,
      hSameTarget: 0,
      hSameTargetGame: 0,
      hSameTargetPercent: 0,
      gSameGoal: 0,
      gSamePercent: 0,
      gSameTarget: 0,
      gSameTargetGame: 0,
      gSameTargetPercent: 0,
    },
    defend: {
      hGrade: 0,
      gGrade: 0,
      hLoss: 0,
      hPercent: 0,
      hTarget: 0,
      hTargetGame: 0,
      hTargetPercent: 0,
      gLoss: 0,
      gPercent: 0,
      gTarget: 0,
      gTargetGame: 0,
      gTargetPercent: 0,
      hSameLoss: 0,
      hSamePercent: 0,
      hSameTarget: 0,
      hSameTargetGame: 0,
      hSameTargetPercent: 0,
      gSameLoss: 0,
      gSamePercent: 0,
      gSameTarget: 0,
      gSameTargetGame: 0,
      gSameTargetPercent: 0,
    },
    other: {
      hCorner: [0, 0],
      gCorner: [0, 0],
      hYellow: [0, 0],
      gYellow: [0, 0],
      hFouls: [0, 0],
      gFouls: [0, 0],
      hControl: [0, 0],
      gControl: [0, 0],
    },
  };
  const comparison = props.comparison || defaultComparison;

  useEffect(() => {
    import("../RadialChart").then((module) => {
      setTeamComparisonChart(() => module.default);
    });
  }, []);

  const team1 = match.homeTeam.name ? capitalizeFirstLetter(match.homeTeam.name) : "";
  const team2 = match.awayTeam.name ? capitalizeFirstLetter(match.awayTeam.name) : "";
  const stats1 = [
    comparison.market.hPercent,
    comparison.defend.hGrade,
    comparison.state.hGrade,
    comparison.attack.hGrade,
  ]; // Giá Trị, Phòng Thủ, Phong Độ, TẤn Công
  const stats2 = [
    comparison.market.gPercent,
    comparison.defend.gGrade,
    comparison.state.gGrade,
    comparison.attack.gGrade,
  ];
  return (
    <div className="flex flex-col mt-5">
      <div className="flex w-full mb-[9px]">
        <div className="bg-button-blue-bet text-white pl-[14px] lg:pl-[39px] py-[2px] w-1/2 rounded-tl-[4px] rounded-bl-[4px]">
          {team1}
        </div>
        <div className="bg-golden-yellow text-button-blue-bet pr-[14px] lg:pr-[39px] py-[2px] w-1/2 text-right rounded-tr-[4px] rounded-br-[4px]">
          {team2}
        </div>
      </div>
      <div className="grid grid-col-1 @lg:grid-cols-2 gap-[12px] md:gap-[40px] flex-col md:flex-row">
        <div className="flex-1 pt-5">
          {TeamComparisonChart ? (
            <TeamComparisonChart
              team1={team1}
              team2={team2}
              stats1={stats1}
              stats2={stats2}
              tab={tab}
            />
          ) : (
            <LoadingInner />
          )}
        </div>
        <div className="flex flex-col w-full gap-[10px]">
          <div className="w-full font-bold text-[10px] px-[18px] py-[7px] divide-x-[1px] [&>*:first-child]:pl-[0] [&>*:last-child]:pr-[0] [&>*]:px-[12px] md:[&>*]:px-[17px] divide-league-dark-detail text-blur-gray bg-white dark:bg-dark-slate rounded-[4px] mb-[20px] flex items-center justify-center">
            <div
              className={`text-nowrap hover:cursor-pointer ${tab === "state" ? "text-button-blue-bet dark:text-stroke-o3" : ""}`}
              onClick={() => {
                setTab("state");
              }}
            >
              Phong độ
            </div>
            <div
              className={`text-nowrap hover:cursor-pointer ${tab === "attack" ? "text-button-blue-bet dark:text-stroke-o3" : ""}`}
              onClick={() => {
                setTab("attack");
              }}
            >
              Tấn Công
            </div>
            <div
              className={`text-nowrap hover:cursor-pointer ${tab === "defend" ? "text-button-blue-bet dark:text-stroke-o3" : ""}`}
              onClick={() => {
                setTab("defend");
              }}
            >
              Phòng Thủ
            </div>
            <div
              className={`text-nowrap hover:cursor-pointer ${tab === "market" ? "text-button-blue-bet dark:text-stroke-o3" : ""}`}
              onClick={() => {
                setTab("market");
              }}
            >
              Giá Trị
            </div>
            <div
              className={`text-nowrap hover:cursor-pointer ${tab === "other" ? "text-button-blue-bet dark:text-stroke-o3" : ""}`}
              onClick={() => {
                setTab("other");
              }}
            >
              Khác
            </div>
          </div>
          {tab === "state" && (
            <div className="">
              <div className="flex flex-col">
                <div className="flex font-[600]">
                  <div className="w-[70px] bg-custom-gradient-compare-strength pl-[16px] pt-[5px] rounded-tl-[4px] rounded-tr-[4px] text-white text-[14px]">
                    {comparison.state.hGrade}%
                  </div>
                  <div className="flex-1 text-center font-[600] text-black dark:text-stroke-o3">
                    So Sánh Phong Độ
                  </div>
                  <div className="w-[70px] bg-custom-gradient-compare-strength-away text-right pr-[10px] pt-[5px] text-button-blue-bet text-[14px]">
                    {comparison.state.gGrade}%
                  </div>
                </div>
                <div className="flex">
                  <div
                    className="flex flex-col text-center h-[7px] bg-button-blue-bet"
                    style={{ width: comparison.state.hGrade + "%" }}
                  ></div>
                  <div
                    className="text-center h-[7px] bg-golden-yellow"
                    style={{ width: comparison.state.gGrade + "%" }}
                  ></div>
                </div>
              </div>
              <div className="flex flex-col text-[10px] gap-[10px]">
                <div className="text-center font-bold">Thành tích</div>
                <div className="flex items-end gap-[15px]">
                  <div className="w-[70px] ">
                    T{comparison.state.all.hWin} H{comparison.state.all.hDraw} B
                    {comparison.state.all.hLoss}
                  </div>
                  <div className="flex flex-col flex-1 text-center gap-[6px]">
                    <div className="">Tất cả</div>
                    <div className="rounded-[4px] bg-light-gray-bold h-[5px] flex">
                      <div className="w-1/2 flex justify-end">
                        <div
                          className="h-full bg-button-blue-bet rounded-l-full"
                          style={{ width: comparison.state.all.hPercent + "%" }}
                        ></div>
                      </div>
                      <div className="w-1/2 justify-start flex">
                        <div
                          className="h-full bg-golden-yellow rounded-r-full"
                          style={{ width: comparison.state.all.gPercent + "%" }}
                        ></div>
                      </div>
                    </div>
                  </div>
                  <div className="w-[70px]">
                    T{comparison.state.all.gWin} H{comparison.state.all.gDraw} B
                    {comparison.state.all.gLoss}
                  </div>
                </div>
                <div className="flex items-end gap-[15px]">
                  <div className="w-[70px] ">
                    T{comparison.state.same.hWin} H{comparison.state.same.hDraw}{" "}
                    B{comparison.state.same.hLoss}
                  </div>
                  <div className="flex flex-col flex-1 text-center gap-[6px]">
                    <div className="">Chủ khách tương đồng</div>
                    <div className="rounded-[4px] bg-light-gray-bold h-[5px] flex">
                      <div className="w-1/2 flex justify-end">
                        <div
                          className="h-full bg-button-blue-bet rounded-l-full"
                          style={{
                            width: comparison.state.same.hPercent + "%",
                          }}
                        ></div>
                      </div>
                      <div className="w-1/2 justify-start flex">
                        <div
                          className="h-full bg-golden-yellow rounded-r-full"
                          style={{
                            width: comparison.state.same.gPercent + "%",
                          }}
                        ></div>
                      </div>
                    </div>
                  </div>
                  <div className="w-[70px]">
                    T{comparison.state.same.gWin} H{comparison.state.same.gDraw}{" "}
                    B{comparison.state.same.gLoss}
                  </div>
                </div>
              </div>
              <div className="flex flex-col text-[10px] gap-[10px] mt-2">
                <div className="text-center font-bold">Chấm điểm</div>
                <div className="flex items-end gap-[15px]">
                  <div className="w-[70px] ">
                    {comparison.state.all.hRating} (
                    {comparison.state.all.hWin +
                      comparison.state.all.hDraw +
                      comparison.state.all.hLoss}{" "}
                    Trận)
                  </div>
                  <div className="flex flex-col flex-1 text-center gap-[6px]">
                    <div className="">Tất cả</div>
                    <div className="rounded-[4px] bg-light-gray-bold h-[5px] flex">
                      <div className="w-1/2 flex justify-end">
                        <div
                          className="h-full bg-button-blue-bet rounded-l-full"
                          style={{
                            width: comparison.state.all.hRatingPercent + "%",
                          }}
                        ></div>
                      </div>
                      <div className="w-1/2 justify-start flex">
                        <div
                          className="h-full bg-golden-yellow rounded-r-full"
                          style={{
                            width: comparison.state.all.gRatingPercent + "%",
                          }}
                        ></div>
                      </div>
                    </div>
                  </div>
                  <div className="w-[70px]">
                    {comparison.state.all.gRating} (
                    {comparison.state.all.gWin +
                      comparison.state.all.gDraw +
                      comparison.state.all.gLoss}{" "}
                    Trận)
                  </div>
                </div>
                <div className="flex items-end gap-[15px]">
                  <div className="w-[70px] ">
                    {comparison.state.same.hRating} (
                    {comparison.state.same.hWin +
                      comparison.state.same.hDraw +
                      comparison.state.same.hLoss}{" "}
                    Trận)
                  </div>
                  <div className="flex flex-col flex-1 text-center gap-[6px]">
                    <div className="">Chủ khách tương đồng</div>
                    <div className="rounded-[4px] bg-light-gray-bold h-[5px] flex">
                      <div className="w-1/2 flex justify-end">
                        <div
                          className="h-full bg-button-blue-bet rounded-l-full"
                          style={{
                            width: comparison.state.same.hRatingPercent + "%",
                          }}
                        ></div>
                      </div>
                      <div className="w-1/2 justify-start flex">
                        <div
                          className="h-full bg-golden-yellow rounded-r-full"
                          style={{
                            width: comparison.state.same.gRatingPercent + "%",
                          }}
                        ></div>
                      </div>
                    </div>
                  </div>
                  <div className="w-[70px]">
                    {comparison.state.same.gRating} (
                    {comparison.state.same.gWin +
                      comparison.state.same.gDraw +
                      comparison.state.same.gLoss}{" "}
                    Trận)
                  </div>
                </div>
              </div>
            </div>
          )}

          {tab === "attack" && (
            <div className="">
              <div className="flex flex-col">
                <div className="flex font-[600]">
                  <div className="w-[70px] bg-custom-gradient-compare-strength pl-[16px] pt-[5px] rounded-tl-[4px] rounded-tr-[4px] text-white text-[14px]">
                    {comparison.attack.hGrade}%
                  </div>
                  <div className="flex-1 text-center font-[600] text-black">
                    So Sánh Tấn Công
                  </div>
                  <div className="w-[70px] bg-custom-gradient-compare-strength-away text-right pr-[10px] pt-[5px] text-button-blue-bet text-[14px]">
                    {comparison.attack.gGrade}%
                  </div>
                </div>
                <div className="flex">
                  <div
                    className="flex flex-col text-center h-[7px] bg-button-blue-bet"
                    style={{ width: comparison.attack.hGrade + "%" }}
                  ></div>
                  <div
                    className="text-center h-[7px] bg-golden-yellow"
                    style={{ width: comparison.attack.gGrade + "%" }}
                  ></div>
                </div>
              </div>
              <div className="flex flex-col text-[10px] gap-[10px]">
                <div className="text-center font-bold">Ghi</div>
                <div className="flex items-end gap-[15px]">
                  <div className="w-[70px] ">
                    {comparison.attack.hGoal}Bàn/{comparison.count}Trận
                  </div>
                  <div className="flex flex-col flex-1 text-center gap-[6px]">
                    <div className="">Tất cả</div>
                    <div className="rounded-[4px] bg-light-gray-bold h-[5px] flex">
                      <div className="w-1/2 flex justify-end">
                        <div
                          className="h-full bg-button-blue-bet rounded-l-full"
                          style={{ width: comparison.attack.hPercent + "%" }}
                        ></div>
                      </div>
                      <div className="w-1/2 justify-start flex">
                        <div
                          className="h-full bg-golden-yellow rounded-r-full"
                          style={{ width: comparison.attack.gPercent + "%" }}
                        ></div>
                      </div>
                    </div>
                  </div>
                  <div className="w-[70px]">
                    {comparison.attack.gGoal}Bàn/{comparison.count}Trận
                  </div>
                </div>
                <div className="flex items-end gap-[15px]">
                  <div className="w-[70px] ">
                    {comparison.attack.hSameGoal}Bàn/
                    {comparison.attack.hSameTargetGame}Trận
                  </div>
                  <div className="flex flex-col flex-1 text-center gap-[6px]">
                    <div className="">Chủ khách tương đồng</div>
                    <div className="rounded-[4px] bg-light-gray-bold h-[5px] flex">
                      <div className="w-1/2 flex justify-end">
                        <div
                          className="h-full bg-button-blue-bet rounded-l-full"
                          style={{
                            width: comparison.attack.hSamePercent + "%",
                          }}
                        ></div>
                      </div>
                      <div className="w-1/2 justify-start flex">
                        <div
                          className="h-full bg-golden-yellow rounded-r-full"
                          style={{
                            width: comparison.attack.gSamePercent + "%",
                          }}
                        ></div>
                      </div>
                    </div>
                  </div>
                  <div className="w-[70px] ">
                    {comparison.attack.gSameGoal}Bàn/
                    {comparison.attack.gSameTargetGame}Trận
                  </div>
                </div>
              </div>
              <div className="flex flex-col text-[10px] gap-[10px] mt-2">
                <div className="text-center font-bold">Sút trúng mục tiêu</div>
                <div className="flex items-end gap-[15px]">
                  <div className="w-[70px] ">
                    {comparison.attack.hTarget}Lần/
                    {comparison.attack.hTargetGame}Trận
                  </div>
                  <div className="flex flex-col flex-1 text-center gap-[6px]">
                    <div className="">Tất cả</div>
                    <div className="rounded-[4px] bg-light-gray-bold h-[5px] flex">
                      <div className="w-1/2 flex justify-end">
                        <div
                          className="h-full bg-button-blue-bet rounded-l-full"
                          style={{
                            width: comparison.attack.hTargetPercent + "%",
                          }}
                        ></div>
                      </div>
                      <div className="w-1/2 justify-start flex">
                        <div
                          className="h-full bg-golden-yellow rounded-r-full"
                          style={{
                            width: comparison.attack.gTargetPercent + "%",
                          }}
                        ></div>
                      </div>
                    </div>
                  </div>
                  <div className="w-[70px] ">
                    {comparison.attack.gTarget}Lần/
                    {comparison.attack.gTargetGame}Trận
                  </div>
                </div>
                <div className="flex items-end gap-[15px]">
                  <div className="w-[70px] ">
                    {comparison.attack.hSameTarget}Lần/
                    {comparison.attack.hSameTargetGame}Trận
                  </div>
                  <div className="flex flex-col flex-1 text-center gap-[6px]">
                    <div className="">Chủ khách tương đồng</div>
                    <div className="rounded-[4px] bg-light-gray-bold h-[5px] flex">
                      <div className="w-1/2 flex justify-end">
                        <div
                          className="h-full bg-button-blue-bet rounded-l-full"
                          style={{
                            width: comparison.attack.hSameTargetPercent + "%",
                          }}
                        ></div>
                      </div>
                      <div className="w-1/2 justify-start flex">
                        <div
                          className="h-full bg-golden-yellow rounded-r-full"
                          style={{
                            width: comparison.attack.gSameTargetPercent + "%",
                          }}
                        ></div>
                      </div>
                    </div>
                  </div>
                  <div className="w-[70px] ">
                    {comparison.attack.gSameTarget}Lần/
                    {comparison.attack.gSameTargetGame}Trận
                  </div>
                </div>
              </div>
            </div>
          )}

          {tab === "defend" && (
            <div className="">
              <div className="flex flex-col">
                <div className="flex font-[600]">
                  <div className="w-[70px] bg-custom-gradient-compare-strength pl-[16px] pt-[5px] rounded-tl-[4px] rounded-tr-[4px] text-white text-[14px]">
                    {comparison.defend.hGrade}%
                  </div>
                  <div className="flex-1 text-center font-[600] text-black dark:text-stroke-o3">
                    So Sánh Phòng Thủ
                  </div>
                  <div className="w-[70px] bg-custom-gradient-compare-strength-away text-right pr-[10px] pt-[5px] text-button-blue-bet text-[14px]">
                    {comparison.defend.gGrade}%
                  </div>
                </div>
                <div className="flex">
                  <div
                    className="flex flex-col text-center h-[7px] bg-button-blue-bet"
                    style={{ width: comparison.defend.hGrade + "%" }}
                  ></div>
                  <div
                    className="text-center h-[7px] bg-golden-yellow"
                    style={{ width: comparison.defend.gGrade + "%" }}
                  ></div>
                </div>
              </div>
              <div className="flex flex-col text-[10px] gap-[10px]">
                <div className="text-center font-bold">Mất</div>
                <div className="flex items-end gap-[15px]">
                  <div className="w-[70px] ">
                    {comparison.defend.hLoss}Bàn/{comparison.count}Trận
                  </div>
                  <div className="flex flex-col flex-1 text-center gap-[6px]">
                    <div className="">Tất cả</div>
                    <div className="rounded-[4px] bg-light-gray-bold h-[5px] flex">
                      <div className="w-1/2 flex justify-end">
                        <div
                          className="h-full bg-button-blue-bet rounded-l-full"
                          style={{ width: comparison.defend.hPercent + "%" }}
                        ></div>
                      </div>
                      <div className="w-1/2 justify-start flex">
                        <div
                          className="h-full bg-golden-yellow rounded-r-full"
                          style={{ width: comparison.defend.gPercent + "%" }}
                        ></div>
                      </div>
                    </div>
                  </div>
                  <div className="w-[70px]">
                    {comparison.defend.gLoss}Bàn/{comparison.count}Trận
                  </div>
                </div>
                <div className="flex items-end gap-[15px]">
                  <div className="w-[70px] ">
                    {comparison.defend.hSameLoss}Bàn/
                    {comparison.defend.hSameTargetGame}Trận
                  </div>
                  <div className="flex flex-col flex-1 text-center gap-[6px]">
                    <div className="">Chủ khách tương đồng</div>
                    <div className="rounded-[4px] bg-light-gray-bold h-[5px] flex">
                      <div className="w-1/2 flex justify-end">
                        <div
                          className="h-full bg-button-blue-bet rounded-l-full"
                          style={{
                            width: comparison.defend.hSamePercent + "%",
                          }}
                        ></div>
                      </div>
                      <div className="w-1/2 justify-start flex">
                        <div
                          className="h-full bg-golden-yellow rounded-r-full"
                          style={{
                            width: comparison.defend.gSamePercent + "%",
                          }}
                        ></div>
                      </div>
                    </div>
                  </div>
                  <div className="w-[70px] ">
                    {comparison.defend.gSameLoss}Bàn/
                    {comparison.defend.gSameTargetGame}Trận
                  </div>
                </div>
              </div>
              <div className="flex flex-col text-[10px] gap-[10px] mt-2">
                <div className="text-center font-bold">
                  Bị sút trúng mục tiêu
                </div>
                <div className="flex items-end gap-[15px]">
                  <div className="w-[70px] ">
                    {comparison.defend.hTarget}Lần/
                    {comparison.defend.hTargetGame}Trận
                  </div>
                  <div className="flex flex-col flex-1 text-center gap-[6px]">
                    <div className="">Tất cả</div>
                    <div className="rounded-[4px] bg-light-gray-bold h-[5px] flex">
                      <div className="w-1/2 flex justify-end">
                        <div
                          className="h-full bg-button-blue-bet rounded-l-full"
                          style={{
                            width: comparison.defend.hTargetPercent + "%",
                          }}
                        ></div>
                      </div>
                      <div className="w-1/2 justify-start flex">
                        <div
                          className="h-full bg-golden-yellow rounded-r-full"
                          style={{
                            width: comparison.defend.gTargetPercent + "%",
                          }}
                        ></div>
                      </div>
                    </div>
                  </div>
                  <div className="w-[70px] ">
                    {comparison.defend.gTarget}Lần/
                    {comparison.defend.gTargetGame}Trận
                  </div>
                </div>
                <div className="flex items-end gap-[15px]">
                  <div className="w-[70px] ">
                    {comparison.defend.hSameTarget}Lần/
                    {comparison.defend.hSameTargetGame}Trận
                  </div>
                  <div className="flex flex-col flex-1 text-center gap-[6px]">
                    <div className="">Chủ khách tương đồng</div>
                    <div className="rounded-[4px] bg-light-gray-bold h-[5px] flex">
                      <div className="w-1/2 flex justify-end">
                        <div
                          className="h-full bg-button-blue-bet rounded-l-full"
                          style={{
                            width: comparison.defend.hSameTargetPercent + "%",
                          }}
                        ></div>
                      </div>
                      <div className="w-1/2 justify-start flex">
                        <div
                          className="h-full bg-golden-yellow rounded-r-full"
                          style={{
                            width: comparison.defend.gSameTargetPercent + "%",
                          }}
                        ></div>
                      </div>
                    </div>
                  </div>
                  <div className="w-[70px] ">
                    {comparison.defend.gSameTarget}Lần/
                    {comparison.defend.gSameTargetGame}Trận
                  </div>
                </div>
              </div>
            </div>
          )}

          {tab === "market" && (
            <div className="">
              <div className="flex flex-col">
                <div className="flex font-[600]">
                  <div className="w-[70px] bg-custom-gradient-compare-strength pl-[16px] pt-[5px] rounded-tl-[4px] rounded-tr-[4px] text-white text-[14px]">
                    {comparison.market.hPercent || "0"}%
                  </div>
                  <div className="flex-1 text-center font-[600] text-black">
                    So Sánh Giá Trị
                  </div>
                  <div className="w-[70px] bg-custom-gradient-compare-strength-away text-right pr-[10px] pt-[5px] text-button-blue-bet text-[14px]">
                    {comparison.market.gPercent || "0"}%
                  </div>
                </div>
                <div className="flex">
                  <div
                    className="flex flex-col text-center h-[7px] bg-button-blue-bet"
                    style={{ width: comparison.market.hPercent + "%" }}
                  ></div>
                  <div
                    className="text-center h-[7px] bg-golden-yellow"
                    style={{ width: comparison.market.gPercent + "%" }}
                  ></div>
                </div>
              </div>
              <div className="flex flex-col text-[10px] gap-[10px] mt-2">
                <div className="flex items-end gap-[15px]">
                  <div className="w-[70px] ">
                    {comparison.market.hMarket} Triệu
                  </div>
                  <div className="flex flex-col flex-1 text-center gap-[6px]">
                    <div className="">So Sánh Giá Trị</div>
                    <div className="rounded-[4px] bg-light-gray-bold h-[5px] flex">
                      <div className="w-1/2 flex justify-end">
                        <div
                          className="h-full bg-button-blue-bet rounded-l-full"
                          style={{ width: comparison.market.hPercent + "%" }}
                        ></div>
                      </div>
                      <div className="w-1/2 justify-start flex">
                        <div
                          className="h-full bg-golden-yellow rounded-r-full"
                          style={{ width: comparison.market.gPercent + "%" }}
                        ></div>
                      </div>
                    </div>
                  </div>
                  <div className="w-[70px] ">
                    {comparison.market.gMarket} Triệu
                  </div>
                </div>
              </div>
            </div>
          )}

          {tab === "other" && (
            <div className="">
              <div className="flex flex-col text-[10px] gap-[10px] mt-2">
                <div className="flex items-end gap-[15px]">
                  <div className="w-[70px] ">{comparison.other.hCorner[0]}</div>
                  <div className="flex flex-col flex-1 text-center gap-[6px]">
                    <div className="">Phạt góc mỗi trận</div>
                    <div className="rounded-[4px] bg-light-gray-bold h-[5px] flex">
                      <div className="w-1/2 flex justify-end">
                        <div
                          className="h-full bg-button-blue-bet rounded-l-full"
                          style={{ width: comparison.other.hCorner[1] + "%" }}
                        ></div>
                      </div>
                      <div className="w-1/2 justify-start flex">
                        <div
                          className="h-full bg-golden-yellow rounded-r-full"
                          style={{ width: comparison.other.gCorner[1] + "%" }}
                        ></div>
                      </div>
                    </div>
                  </div>
                  <div className="w-[70px] ">{comparison.other.gCorner[0]}</div>
                </div>
                <div className="flex items-end gap-[15px]">
                  <div className="w-[70px] ">{comparison.other.hYellow[0]}</div>
                  <div className="flex flex-col flex-1 text-center gap-[6px]">
                    <div className="">Thẻ vàng mỗi trận</div>
                    <div className="rounded-[4px] bg-light-gray-bold h-[5px] flex">
                      <div className="w-1/2 flex justify-end">
                        <div
                          className="h-full bg-button-blue-bet rounded-l-full"
                          style={{ width: comparison.other.hYellow[1] + "%" }}
                        ></div>
                      </div>
                      <div className="w-1/2 justify-start flex">
                        <div
                          className="h-full bg-golden-yellow rounded-r-full"
                          style={{ width: comparison.other.gYellow[1] + "%" }}
                        ></div>
                      </div>
                    </div>
                  </div>
                  <div className="w-[70px] ">{comparison.other.gYellow[0]}</div>
                </div>
                <div className="flex items-end gap-[15px]">
                  <div className="w-[70px] ">{comparison.other.hFouls[0]}</div>
                  <div className="flex flex-col flex-1 text-center gap-[6px]">
                    <div className="">Phạm lỗi mỗi trận</div>
                    <div className="rounded-[4px] bg-light-gray-bold h-[5px] flex">
                      <div className="w-1/2 flex justify-end">
                        <div
                          className="h-full bg-button-blue-bet rounded-l-full"
                          style={{ width: comparison.other.hFouls[1] + "%" }}
                        ></div>
                      </div>
                      <div className="w-1/2 justify-start flex">
                        <div
                          className="h-full bg-golden-yellow rounded-r-full"
                          style={{ width: comparison.other.gFouls[1] + "%" }}
                        ></div>
                      </div>
                    </div>
                  </div>
                  <div className="w-[70px] ">{comparison.other.gFouls[0]}</div>
                </div>
                <div className="flex items-end gap-[15px]">
                  <div className="w-[70px] ">
                    {comparison.other.hControl[0]}
                  </div>
                  <div className="flex flex-col flex-1 text-center gap-[6px]">
                    <div className="">Tỷ lệ kiểm soát bóng</div>
                    <div className="rounded-[4px] bg-light-gray-bold h-[5px] flex">
                      <div className="w-1/2 flex justify-end">
                        <div
                          className="h-full bg-button-blue-bet rounded-l-full"
                          style={{ width: comparison.other.hControl[1] + "%" }}
                        ></div>
                      </div>
                      <div className="w-1/2 justify-start flex">
                        <div
                          className="h-full bg-golden-yellow rounded-r-full"
                          style={{ width: comparison.other.gControl[1] + "%" }}
                        ></div>
                      </div>
                    </div>
                  </div>
                  <div className="w-[70px] ">
                    {comparison.other.gControl[0]}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default React.memo(DataCompareStrength);
